import Keycloak from 'keycloak-js';

export class KeyCloakAuthService {
  keycloakInstance = new Keycloak('/keycloak/keycloak.json');
  initialized = false;

  Initialize = async () => {
    try {
      if (!window.origin.startsWith('https')) {
        this.initialized = true;
        return false;
      }

      const authed = await this.keycloakInstance.init({
        onLoad: 'check-sso',
        responseMode: 'query',
        checkLoginIframe: true,
        redirectUri: window.location.href,
        messageReceiveTimeout: 3000
      });
      this.initialized = true;
      return authed;
    } catch (error) {
      console.error('keycloak init error', error);
      this.initialized = true;
    }
  };

  IsInitialized = () => this.initialized;

  GetUserName = () => this.keycloakInstance?.tokenParsed?.preferred_username;

  GetAccessToken = () => this.keycloakInstance?.token;

  GetUserRoles = () => {
    if (this.keycloakInstance.resourceAccess === undefined) {
      return undefined;
    }
    // eslint-disable-next-line dot-notation
    return this.keycloakInstance.resourceAccess['vue'].roles;
  };

  UpdateToken = successCallback =>
    this.keycloakInstance
      .updateToken(5)
      .then(successCallback)
      .catch(this.Login);

  Login = this.keycloakInstance.login;
  Logout = this.keycloakInstance.logout;

  IsLoggedIn = () => !!this.keycloakInstance.token;
}

export const registerKeyCloakAuthService = async app => {
  const keycloak = new KeyCloakAuthService();
  window.$keycloak = keycloak;
  app.config.globalProperties.$keycloak = keycloak;

  await keycloak.Initialize();
};
